import React, { useEffect } from "react";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { MainCard } from "@ezhou/app_mantis_1_1";

import { InactivatableCrudDataGrid } from "../common/InactivatableCrudDataGrid";

import { dummyOrganizationRow } from "./model/metaData";
import { OrganizationUsers } from "./OrganizationUsers";

const Organizations = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("OrganizationsPage");

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const detailComponent = (props: any) => {
    return <OrganizationUsers masterData={props.data.data} pageProps={pageProps} logger={logger} />;
  };

  return (
    <MainCard>
      <InactivatableCrudDataGrid
        pageProps={pageProps}
        logger={logger}
        dummyRow={dummyOrganizationRow}
        baseUrl="organizations"
        keyExpr="organizationId"
        isKeyAutoGenerated={true}
        formTitle="Organization"
        formColCount={2}
        formColSpan={2}
        masterDetailComponent={detailComponent}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      ></InactivatableCrudDataGrid>
    </MainCard>
  );
};

export default Organizations;
